import React, { useEffect }  from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { makeBreadCrumbReach } from '../Functions/SetHeaders';
const Styles = styled.div`
  margin: 1.5rem var(--universal-pad);
  display: flex;
  align-items: center;
  gap: 8px;
  color: #036663;
  &.ltr {
    svg {
      transform: rotate(180deg);
    }
  }
  a {
    color: var(--n-grey-2);
    text-decoration: none;
    &:hover {
      color: #036663;
    }
  }
`


export default function BreadCrumb28 (props){
  const location = useLocation();
  const params = useParams()

  const {data: dataRaw, dataMain, lan} = props;
  const data = JSON.parse(dataRaw);
  useEffect(() => {
    makeDataForReach();
  }, [])
  const makeDataForReach = () => {
    let path = location.pathname.split("/")
    let lang = path.splice(1, 1);
    lang = lang[0]

    let htmlPath = [];
    let stage = [];
    let lastLink = "";
    for (let i = 0; i < path.length; i++) {
      const element = path[i];
      let itemsTree = {};
      for (let j = 0; j < stage.length; j++) {
        const jkey = stage[j];
        if(Object.keys(itemsTree).length){
          itemsTree = itemsTree[jkey];
        } else {
          itemsTree = locationTree[jkey];
        }
      }

      if(i === 0 && element === ""){
        lastLink = "https://luxintrip.com/" + lang
        htmlPath.push(
          {"@type":"ListItem", "position":i + 1, "name": locationTree["/"].name[lan.filename], "item": "https://luxintrip.com/" + lang}
        )
        stage.push("/");
      } else if (itemsTree["/" + element]) {
        lastLink = "https://luxintrip.com/" + lang + "/" + element
        if(i === path.length - 1){
          htmlPath.push(
            {"@type":"ListItem", "position":i + 1, "name": itemsTree["/" + element].name[lan.filename]}
          )
        } else {
          htmlPath.push(
            {"@type":"ListItem", "position":i + 1, "name": itemsTree["/" + element].name[lan.filename], "item": "https://luxintrip.com/" + lang + "/" + element}
          )
          stage.push("/" + element);
        }
      } else if(itemsTree["/${continent}"]){
        if(dataMain.Continent && dataMain.Continent.Continent_Url === params.continent){
          lastLink = "https://luxintrip.com/" + lang + "/tour/" + params.continent
          if(i === path.length - 1){
            htmlPath.push(
              {"@type":"ListItem", "position":i + 1, "name": (lan.filename === "fa" ? dataMain.Continent.Continent_FaName : dataMain.Continent.Continent_EnName)}
            )
          } else {
            htmlPath.push(
              {"@type":"ListItem", "position":i + 1, "name": (lan.filename === "fa" ? dataMain.Continent.Continent_FaName : dataMain.Continent.Continent_EnName), "item": "https://luxintrip.com/" + lang + "/tour/" + params.continent}
            )
          }
        }
        stage.push("/${continent}");
        } else if(itemsTree["/${country}"]){
          if(dataMain.Country && dataMain.Country.Country_Url === params.country){
            lastLink = "https://luxintrip.com/" + lang + "/" + params.continent + "/" + params.country
            if(i === path.length - 1){
              htmlPath.push(
                {"@type":"ListItem", "position":i + 1, "name": (lan.filename === "fa" ? dataMain.Country.Country_Name : dataMain.Country.Country_En_Name)}
              )
            } else {
              htmlPath.push(
                {"@type":"ListItem", "position":i + 1, "name": (lan.filename === "fa" ? dataMain.Country.Country_Name : dataMain.Country.Country_En_Name), "item": "https://luxintrip.com/" + lang + "/" + params.continent + "/" + params.country}
              )
            }
          }
        }
    }
    makeBreadCrumbReach(lan.filename, {
        "@type":"BreadcrumbList",
        "@id":lastLink + "/#breadcrumb",
        "itemListElement": htmlPath
    })
  }



  let pathname = location.pathname.split("/")
  let lang = pathname.splice(1, 1);
  lang = lang[0]





  const makeBreadCrumb = (path = []) => {
    let htmlPath = [];
    let stage = [];

    for (let i = 0; i < path.length; i++) {
      const element = path[i];
      let itemsTree = {};
      for (let j = 0; j < stage.length; j++) {
        const jkey = stage[j];
        if(Object.keys(itemsTree).length){
          itemsTree = itemsTree[jkey];
        } else {
          itemsTree = locationTree[jkey];
        }
      }

      if(i === 0 && element === ""){
        htmlPath.push(
          <Link to={"/" + lang + "/"} key={i+"-l"} className='text'>{locationTree["/"].name[lan.filename]}</Link>
        )
        stage.push("/");
      } else if (itemsTree["/" + element]) {
        htmlPath.push(
          <svg width="16" height="16" key={i+"-i"} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.83317 8.00002C0.83317 11.9534 4.0465 15.1667 7.99984 15.1667C11.9532 15.1667 15.1665 11.9534 15.1665 8.00002C15.1665 4.04669 11.9532 0.833353 7.99984 0.833353C4.0465 0.833353 0.83317 4.04669 0.83317 8.00002ZM14.1665 8.00002C14.1665 11.4 11.3998 14.1667 7.99984 14.1667C4.59984 14.1667 1.83317 11.4 1.83317 8.00002C1.83317 4.60002 4.59984 1.83335 7.99984 1.83335C11.3998 1.83335 14.1665 4.60002 14.1665 8.00002Z" fill="#979797"/>
            <path d="M5.99355 8.00002C5.99355 8.12668 6.04021 8.25335 6.14021 8.35335L8.49355 10.7067C8.68688 10.9 9.00688 10.9 9.20021 10.7067C9.39355 10.5134 9.39355 10.1934 9.20021 10L7.20022 8.00002L9.20021 6.00002C9.39355 5.80668 9.39355 5.48668 9.20021 5.29335C9.00688 5.10002 8.68688 5.10002 8.49355 5.29335L6.14021 7.64668C6.04021 7.74668 5.99355 7.87335 5.99355 8.00002Z" fill="#979797"/>
          </svg>
        )
        if(i === path.length - 1){
          htmlPath.push(
            <div className='text' key={i+"-l"}>{itemsTree["/" + element].name[lan.filename]}</div>
          )
        } else {
          htmlPath.push(
            <Link to={"/" + lang + "/" + element} key={i+"-l"} className='text'>{itemsTree["/" + element].name[lan.filename]}</Link>
          )
          stage.push("/" + element);
        }
        
      } else if(itemsTree["/${continent}"]){
        // check for continent data
        // if exist add
        if(dataMain.Continent && dataMain.Continent.Continent_Url === params.continent){
          htmlPath.push(
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" key={i+"-i"}>
              <path d="M0.83317 8.00002C0.83317 11.9534 4.0465 15.1667 7.99984 15.1667C11.9532 15.1667 15.1665 11.9534 15.1665 8.00002C15.1665 4.04669 11.9532 0.833353 7.99984 0.833353C4.0465 0.833353 0.83317 4.04669 0.83317 8.00002ZM14.1665 8.00002C14.1665 11.4 11.3998 14.1667 7.99984 14.1667C4.59984 14.1667 1.83317 11.4 1.83317 8.00002C1.83317 4.60002 4.59984 1.83335 7.99984 1.83335C11.3998 1.83335 14.1665 4.60002 14.1665 8.00002Z" fill="#979797"/>
              <path d="M5.99355 8.00002C5.99355 8.12668 6.04021 8.25335 6.14021 8.35335L8.49355 10.7067C8.68688 10.9 9.00688 10.9 9.20021 10.7067C9.39355 10.5134 9.39355 10.1934 9.20021 10L7.20022 8.00002L9.20021 6.00002C9.39355 5.80668 9.39355 5.48668 9.20021 5.29335C9.00688 5.10002 8.68688 5.10002 8.49355 5.29335L6.14021 7.64668C6.04021 7.74668 5.99355 7.87335 5.99355 8.00002Z" fill="#979797"/>
            </svg>
          )
          if(i === path.length - 1){
            htmlPath.push(
              <div className='text' key={i+"-l"}>{lan.filename === "fa" ? dataMain.Continent.Continent_FaName : dataMain.Continent.Continent_EnName}</div>
            )
          } else {
            htmlPath.push(
              <Link to={"/" + lang + "/tour/" + params.continent} key={i+"-l"} className='text'>{lan.filename === "fa" ? dataMain.Continent.Continent_FaName : dataMain.Continent.Continent_EnName}</Link>
            )
          }
        }
        stage.push("/${continent}");
        } else if(itemsTree["/${country}"]){
          // check for continent data
          // if exist add
          if(dataMain.Country && dataMain.Country.Country_Url === params.country){
            htmlPath.push(
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" key={i+"-i"}>
                <path d="M0.83317 8.00002C0.83317 11.9534 4.0465 15.1667 7.99984 15.1667C11.9532 15.1667 15.1665 11.9534 15.1665 8.00002C15.1665 4.04669 11.9532 0.833353 7.99984 0.833353C4.0465 0.833353 0.83317 4.04669 0.83317 8.00002ZM14.1665 8.00002C14.1665 11.4 11.3998 14.1667 7.99984 14.1667C4.59984 14.1667 1.83317 11.4 1.83317 8.00002C1.83317 4.60002 4.59984 1.83335 7.99984 1.83335C11.3998 1.83335 14.1665 4.60002 14.1665 8.00002Z" fill="#979797"/>
                <path d="M5.99355 8.00002C5.99355 8.12668 6.04021 8.25335 6.14021 8.35335L8.49355 10.7067C8.68688 10.9 9.00688 10.9 9.20021 10.7067C9.39355 10.5134 9.39355 10.1934 9.20021 10L7.20022 8.00002L9.20021 6.00002C9.39355 5.80668 9.39355 5.48668 9.20021 5.29335C9.00688 5.10002 8.68688 5.10002 8.49355 5.29335L6.14021 7.64668C6.04021 7.74668 5.99355 7.87335 5.99355 8.00002Z" fill="#979797"/>
              </svg>
            )
            if(i === path.length - 1){
              htmlPath.push(
                <div className='text' key={i+"-l"}>{lan.filename === "fa" ? dataMain.Country.Country_Name : dataMain.Country.Country_En_Name}</div>
              )
            } else {
              htmlPath.push(
                <Link to={"/" + lang + "/" + params.continent + "/" + params.country} key={i+"-l"} className='text'>{lan.filename === "fa" ? dataMain.Country.Country_Name : dataMain.Country.Country_En_Name}</Link>
              )
            }
          }
        }
    }
    return htmlPath
  }
  return (
    <Styles className={lan.dir}>
      {makeBreadCrumb(pathname)}
    </Styles>
  )
}
const locationTree = {
  "/": {
    name: {
      "fa": "لوکسین تریپ",
      "en": "Luxin Trip",
    },
    "/travel-agency": {
      name: {
        "fa": "آژانس مسافرتی",
        "en": "Travel agencies"
      }
    },
    "/tour-operator": {
      name: {
        "fa": "کارگزار تور",
        "en": "Tour operators"
      }
    },
    "/contactus": {
      name: {
        "fa": "تماس باما",
        "en": "Contact Us"
      }
    },
    "/aboutus": {
      name: {
        "fa": "درباره ما",
        "en": "About Us"
      }
    },
    "/tour": {
      name: {
        "fa": "مقصد تور",
        "en": "Tour destination"
      },
      "/${continent}": {
        name: "${continent}",
        "/${country}": {
          name: "${country}"
        }
      }
    }
  }
}